import { FINANCES_RECONCILIATION, FINANCES_TRANSACTIONS, FINANCES_ETATS } from "../../core/constants/layout";
import { useLayoutContext } from "../../core/context/layout-context";
import { useFinanceStore } from "./finance-store";
import FinanceDashboard from "./finance-dashboard";
import FinanceReconciliation from "./finance-reconciliation";
import FinanceTransactions from "./finance-transactions";
import FinanceEtats from "./finance-etats";

export default function FinancePage() {
  const { selectChildren } = useLayoutContext();
  // Shared so reconciliation work shows up in transactions and reports.
  const store = useFinanceStore();

  const content = () => {
    switch (selectChildren) {
      case FINANCES_RECONCILIATION:
        return <FinanceReconciliation store={store} />;
      case FINANCES_TRANSACTIONS:
        return <FinanceTransactions store={store} />;
      case FINANCES_ETATS:
        return <FinanceEtats store={store} />;
      default:
        return <FinanceDashboard store={store} />;
    }
  };

  return <div className="pt-[50px] pb-6 min-h-screen bg-[#fbf8f4] flex flex-col">{content()}</div>;
}
